const { CALL_INTAKE_V2_API } = require('middleware/intakeV2Api');
const {
  DELETE_EXPENSE_CODES_REQUEST,
  DELETE_EXPENSE_CODES_SUCCESS,
  DELETE_EXPENSE_CODES_FAILURE,
  UPDATE_EXPENSE_CODES_REQUEST,
  UPDATE_EXPENSE_CODES_SUCCESS,
  UPDATE_EXPENSE_CODES_FAILURE,
  POST_EXPENSE_CODES_REQUEST,
  POST_EXPENSE_CODES_SUCCESS,
  POST_EXPENSE_CODES_FAILURE,
  GET_EXPENSE_CODES_REQUEST,
  GET_EXPENSE_CODES_SUCCESS,
  GET_EXPENSE_CODES_FAILURE,
  GET_EXPENSE_CODES_BY_CLIENT_ID_REQUEST,
  GET_EXPENSE_CODES_BY_CLIENT_ID_SUCCESS,
  GET_EXPENSE_CODES_BY_CLIENT_ID_FAILURE,
  GET_INSPECTORS_REQUEST,
  GET_INSPECTORS_SUCCESS,
  GET_INSPECTORS_FAILURE,
  POST_INSPECTORS_REQUEST,
  POST_INSPECTORS_SUCCESS,
  POST_INSPECTORS_FAILURE,
  UPDATE_INSPECTORS_REQUEST,
  UPDATE_INSPECTORS_FAILURE,
  DELETE_INSPECTORS_REQUEST,
  DELETE_INSPECTORS_SUCCESS,
  DELETE_INSPECTORS_FAILURE,
  GET_VENDORS_REQUEST,
  GET_VENDORS_SUCCESS,
  GET_VENDORS_FAILURE,
  POST_VENDORS_REQUEST,
  POST_VENDORS_SUCCESS,
  POST_VENDORS_FAILURE,
  UPDATE_VENDOR_DETAILS_REQUEST,
  UPDATE_VENDOR_DETAILS_SUCCESS,
  UPDATE_VENDOR_DETAILS_FAILURE,
  DELETE_VENDORS_REQUEST,
  DELETE_VENDORS_SUCCESS,
  DELETE_VENDORS_FAILURE,
  GET_VENDOR_CONTACT_REQUEST,
  GET_VENDOR_CONTACT_SUCCESS,
  GET_VENDOR_CONTACT_FAILURE,
  POST_VENDOR_CONTACT_REQUEST,
  POST_VENDOR_CONTACT_SUCCESS,
  POST_VENDOR_CONTACT_FAILURE,
  UPDATE_VENDOR_CONTACT_REQUEST,
  UPDATE_VENDOR_CONTACT_SUCCESS,
  UPDATE_VENDOR_CONTACT_FAILURE,
  DELETE_VENDOR_CONTACT_REQUEST,
  DELETE_VENDOR_CONTACT_SUCCESS,
  DELETE_VENDOR_CONTACT_FAILURE,
  GET_ALL_BROKER_AGENTS_REQUEST,
  GET_ALL_BROKER_AGENTS_SUCCESS,
  GET_ALL_BROKER_AGENTS_FAILURE,
  GET_BROKER_AGENTS_BY_ID_REQUEST,
  GET_BROKER_AGENTS_BY_ID_SUCCESS,
  GET_BROKER_AGENTS_BY_ID_FAILURE,
  POST_BROKER_AGENTS_SUCCESS,
  POST_BROKER_AGENTS_FAILURE,
  UPDATE_BROKER_AGENTS_REQUEST,
  UPDATE_BROKER_AGENTS_SUCCESS,
  UPDATE_BROKER_AGENTS_FAILURE,
  DELETE_BROKER_AGENTS_REQUEST,
  DELETE_BROKER_AGENTS_SUCCESS,
  DELETE_BROKER_AGENTS_FAILURE,
  GET_TAX_POLICIES_REQUEST,
  GET_TAX_POLICIES_SUCCESS,
  GET_TAX_POLICIES_FAILURE,
  POST_TAX_POLICY_REQUEST,
  POST_TAX_POLICY_SUCCESS,
  POST_TAX_POLICY_FAILURE,
  UPDATE_TAX_POLICY_REQUEST,
  UPDATE_TAX_POLICY_SUCCESS,
  UPDATE_TAX_POLICY_FAILURE,
  DELETE_TAX_POLICY_REQUEST,
  DELETE_TAX_POLICY_SUCCESS,
  DELETE_TAX_POLICY_FAILURE,
  POST_BROKER_AGENTS_REQUEST,
  UPDATE_INSPECTORS_SUCCESS,
  GET_TITLE_REP_REQUEST,
  GET_TITLE_REP_SUCCESS,
  GET_TITLE_REP_FAILURE,
  GET_VENDOR_DOCUMENTS_REQUEST, GET_VENDOR_DOCUMENTS_SUCCESS, GET_VENDOR_DOCUMENTS_FAILURE,
  POST_VENDOR_DOCUMENT_REQUEST, POST_VENDOR_DOCUMENT_SUCCESS, POST_VENDOR_DOCUMENT_FAILURE,
  UPDATE_VENDOR_DOCUMENT_REQUEST, UPDATE_VENDOR_DOCUMENT_SUCCESS, UPDATE_VENDOR_DOCUMENT_FAILURE,
  DELETE_VENDOR_DOCUMENT_REQUEST, DELETE_VENDOR_DOCUMENT_SUCCESS, DELETE_VENDOR_DOCUMENT_FAILURE,
  GET_VENDOR_HISTORY_REQUEST, GET_VENDOR_HISTORY_SUCCESS, GET_VENDOR_HISTORY_FAILURE,
  GET_VENDOR_NOTES_BY_AUTH_FAILURE, GET_VENDOR_NOTES_BY_AUTH_REQUEST, GET_VENDOR_NOTES_BY_AUTH_SUCCESS,
  GET_VENDOR_NOTES_FAILURE, GET_VENDOR_NOTES_REQUEST, GET_VENDOR_NOTES_SUCCESS,
  POST_VENDOR_NOTE_FAILURE, POST_VENDOR_NOTE_REQUEST, POST_VENDOR_NOTE_SUCCESS,
  UPDATE_VENDOR_NOTE_FAILURE, UPDATE_VENDOR_NOTE_REQUEST, UPDATE_VENDOR_NOTE_SUCCESS,
  DELETE_VENDOR_NOTE_FAILURE, DELETE_VENDOR_NOTE_REQUEST, DELETE_VENDOR_NOTE_SUCCESS,
  GET_VENDOR_NOTE_FAILURE, GET_VENDOR_NOTE_REQUEST, GET_VENDOR_NOTE_SUCCESS,
  GET_VENDOR_BANKING_INFO_REQUEST,
  GET_VENDOR_BANKING_INFO_SUCCESS,
  GET_VENDOR_BANKING_INFO_FAILURE,
  GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_REQUEST,
  GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_SUCCESS,
  GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_FAILURE,
  GET_VENDOR_BANKING_INFO_BY_ID_REQUEST,
  GET_VENDOR_BANKING_INFO_BY_ID_SUCCESS,
  GET_VENDOR_BANKING_INFO_BY_ID_FAILURE,
  POST_VENDOR_BANKING_INFO_REQUEST,
  POST_VENDOR_BANKING_INFO_SUCCESS,
  POST_VENDOR_BANKING_INFO_FAILURE,
  UPDATE_VENDOR_BANKING_INFO_REQUEST,
  UPDATE_VENDOR_BANKING_INFO_SUCCESS,
  UPDATE_VENDOR_BANKING_INFO_FAILURE,
  DELETE_VENDOR_BANKING_INFO_REQUEST,
  DELETE_VENDOR_BANKING_INFO_SUCCESS,
  DELETE_VENDOR_BANKING_INFO_FAILURE,
  GET_VENDOR_DETAILS_FAILURE,
  GET_VENDOR_DETAILS_REQUEST,
  GET_VENDOR_DETAILS_SUCCESS,
  SET_VENDOR_ID,
  MORREALE_EQUITY_IMPORT_REQUEST,
  MORREALE_EQUITY_IMPORT_SUCCESS,
  MORREALE_EQUITY_IMPORT_FAILURE
} = require('../types/dataManagementTypes');

export const deleteExpenseCodes = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_EXPENSE_CODES_REQUEST, DELETE_EXPENSE_CODES_SUCCESS, DELETE_EXPENSE_CODES_FAILURE],
      authenticated: true,
      endpoint: `api/ExpenseCodes/${id}`,
      method: 'DELETE',
    },
  };
};
export const updateExpenseCodes = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EXPENSE_CODES_REQUEST, UPDATE_EXPENSE_CODES_SUCCESS, UPDATE_EXPENSE_CODES_FAILURE],
      authenticated: true,
      endpoint: 'api/ExpenseCodes',
      method: 'PUT',
      payload: values,
    },
  };
};
export const postExpenseCodes = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EXPENSE_CODES_REQUEST, POST_EXPENSE_CODES_SUCCESS, POST_EXPENSE_CODES_FAILURE],
      authenticated: true,
      endpoint: 'api/ExpenseCodes',
      method: 'POST',
      payload: values,
    },
  };
};
export const getExpenseCodes = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXPENSE_CODES_REQUEST, GET_EXPENSE_CODES_SUCCESS, GET_EXPENSE_CODES_FAILURE],
      authenticated: true,
      endpoint: 'api/ExpenseCodes',
      method: 'GET',
    },
  };
};

export const getExpenseCodesByClientId = (clientId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXPENSE_CODES_BY_CLIENT_ID_REQUEST, GET_EXPENSE_CODES_BY_CLIENT_ID_SUCCESS, GET_EXPENSE_CODES_BY_CLIENT_ID_FAILURE],
      authenticated: true,
      endpoint: `api/ExpenseCodes/getByClientId/${clientId}`,
      method: 'GET',
    },
  };
};
/* ^ End Homesale Equity */

export const getInspectors = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_INSPECTORS_REQUEST, GET_INSPECTORS_SUCCESS, GET_INSPECTORS_FAILURE],
      authenticated: true,
      endpoint: 'api/inspectors',
      method: 'GET',
    },
  };
};

export const postInspector = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_INSPECTORS_REQUEST, POST_INSPECTORS_SUCCESS, POST_INSPECTORS_FAILURE],
      authenticated: true,
      endpoint: 'api/inspectors',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateInspector = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_INSPECTORS_REQUEST, UPDATE_INSPECTORS_SUCCESS, UPDATE_INSPECTORS_FAILURE],
      authenticated: true,
      endpoint: 'api/inspectors',
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteInspector = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_INSPECTORS_REQUEST, DELETE_INSPECTORS_SUCCESS, DELETE_INSPECTORS_FAILURE],
      authenticated: true,
      endpoint: `api/inspectors/${id}`,
      method: 'DELETE',
    },
  };
};

/* Broker/Agent endpoints */

export const getBrokerAgents = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_BROKER_AGENTS_REQUEST, GET_ALL_BROKER_AGENTS_SUCCESS, GET_ALL_BROKER_AGENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/common/agents',
      method: 'GET',
    },
  };
};

export const getBrokerAgentsById = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_BROKER_AGENTS_BY_ID_REQUEST, GET_BROKER_AGENTS_BY_ID_SUCCESS, GET_BROKER_AGENTS_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/BrokerAgents/${id}`,
      method: 'GET',
    },
  };
};

export const postBrokerAgents = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_BROKER_AGENTS_REQUEST, POST_BROKER_AGENTS_SUCCESS, POST_BROKER_AGENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/BrokerAgents/',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateBrokerAgents = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_BROKER_AGENTS_REQUEST, UPDATE_BROKER_AGENTS_SUCCESS, UPDATE_BROKER_AGENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/BrokerAgents/',
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteBrokerAgents = (brokerAgentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_BROKER_AGENTS_REQUEST, DELETE_BROKER_AGENTS_SUCCESS, DELETE_BROKER_AGENTS_FAILURE],
      authenticated: true,
      endpoint: `api/BrokerAgents/${brokerAgentId}`,
      method: 'DELETE',
    },
  };
};
/* Tax Policies Calls */

export const getTaxPolicies = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TAX_POLICIES_REQUEST, GET_TAX_POLICIES_SUCCESS, GET_TAX_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'api/TaxPolicys',
      method: 'GET',
    },
  };
};

export const postTaxPolicy = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TAX_POLICY_REQUEST, POST_TAX_POLICY_SUCCESS, POST_TAX_POLICY_FAILURE],
      authenticated: true,
      endpoint: 'api/TaxPolicys',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateTaxPolicy = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_TAX_POLICY_REQUEST, UPDATE_TAX_POLICY_SUCCESS, UPDATE_TAX_POLICY_FAILURE],
      authenticated: true,
      endpoint: 'api/TaxPolicys',
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteTaxPolicy = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_TAX_POLICY_REQUEST, DELETE_TAX_POLICY_SUCCESS, DELETE_TAX_POLICY_FAILURE],
      authenticated: true,
      endpoint: `api/TaxPolicys/${id}`,
      method: 'DELETE',
    },
  };
};

export const getTitleReps = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TITLE_REP_REQUEST, GET_TITLE_REP_SUCCESS, GET_TITLE_REP_FAILURE],
      authenticated: true,
      endpoint: 'api/titleRep',
    },
  };
};


/* Vendor Requests */

export const setVendorId = id => ({
  type: SET_VENDOR_ID,
  response: id,
});

export const getVendors = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDORS_REQUEST, GET_VENDORS_SUCCESS, GET_VENDORS_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors',
      method: 'GET',
    },
  };
};

export const getVendorDetails = (vendorId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_DETAILS_REQUEST, GET_VENDOR_DETAILS_SUCCESS, GET_VENDOR_DETAILS_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/getById/${vendorId}`,
      method: 'GET',
    },
  };
};

export const postVendor = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VENDORS_REQUEST, POST_VENDORS_SUCCESS, POST_VENDORS_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateVendorDetails = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VENDOR_DETAILS_REQUEST, UPDATE_VENDOR_DETAILS_SUCCESS, UPDATE_VENDOR_DETAILS_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors',
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteVendor = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VENDORS_REQUEST, DELETE_VENDORS_SUCCESS, DELETE_VENDORS_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/${id}`,
      method: 'DELETE',
    },
  };
};

export const getVendorContacts = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_CONTACT_REQUEST, GET_VENDOR_CONTACT_SUCCESS, GET_VENDOR_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/contacts',
      method: 'GET',
    },
  };
};

export const postVendorContact = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VENDOR_CONTACT_REQUEST, POST_VENDOR_CONTACT_SUCCESS, POST_VENDOR_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/contacts',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateVendorContact = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VENDOR_CONTACT_REQUEST, UPDATE_VENDOR_CONTACT_SUCCESS, UPDATE_VENDOR_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/contacts',
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteVendorContact = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VENDOR_CONTACT_REQUEST, DELETE_VENDOR_CONTACT_SUCCESS, DELETE_VENDOR_CONTACT_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/contacts/${id}`,
      method: 'DELETE',
    },
  };
};

/* Vendor Documents endpoints */

export const getVendorDocuments = (vendorId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_DOCUMENTS_REQUEST, GET_VENDOR_DOCUMENTS_SUCCESS, GET_VENDOR_DOCUMENTS_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/${vendorId}/document`,
      method: 'GET',
    },
  };
};

export const postVendorDocument = (values, vendorId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VENDOR_DOCUMENT_REQUEST, POST_VENDOR_DOCUMENT_SUCCESS, POST_VENDOR_DOCUMENT_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/${vendorId}/document`,
      method: 'POST',
      payload: values,
      context: { vendorId: vendorId }
    },
  };
};

export const updateVendorDocument = (values, vendorId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VENDOR_DOCUMENT_REQUEST, UPDATE_VENDOR_DOCUMENT_SUCCESS, UPDATE_VENDOR_DOCUMENT_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/${vendorId}/document`,
      method: 'PUT',
      payload: values,
      context: { vendorId: vendorId }
    },
  };
};

export const deleteVendorDocument = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VENDOR_DOCUMENT_REQUEST, DELETE_VENDOR_DOCUMENT_SUCCESS, DELETE_VENDOR_DOCUMENT_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/document/${id}`,
      method: 'DELETE',
    },
  };
};

/* Vendor history endpoints */

export const getVendorHistory = (vendorId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_HISTORY_REQUEST, GET_VENDOR_HISTORY_SUCCESS, GET_VENDOR_HISTORY_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/history/${vendorId}`,
      method: 'GET',
    },
  };
};

// VENDOR AUTH NOTES

export const getAllVendorAuthNotes = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_NOTES_REQUEST, GET_VENDOR_NOTES_SUCCESS, GET_VENDOR_NOTES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/authNotes',
      method: 'GET',
    },
  };
};

export const getAllVendorAuthNotesByAuthId = (authorizationId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_NOTES_BY_AUTH_REQUEST, GET_VENDOR_NOTES_BY_AUTH_SUCCESS, GET_VENDOR_NOTES_BY_AUTH_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authNotes/getAllNotes/${authorizationId}`,
      method: 'GET',
    },
  };
};

export const getVendorAuthNote = (noteId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_NOTE_REQUEST, GET_VENDOR_NOTE_SUCCESS, GET_VENDOR_NOTE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authNotes/${noteId}`,
      method: 'GET',
    },
  };
};

export const postVendorAuthNote = (values) => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VENDOR_NOTE_REQUEST, POST_VENDOR_NOTE_SUCCESS, POST_VENDOR_NOTE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authNotes/${username}`,
      method: 'POST',
      payload: values,
    },
  };
};

export const updateVendorAuthNote = (values) => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VENDOR_NOTE_REQUEST, UPDATE_VENDOR_NOTE_SUCCESS, UPDATE_VENDOR_NOTE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authNotes/${username}`,
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteVendorAuthNote = (noteId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VENDOR_NOTE_REQUEST, DELETE_VENDOR_NOTE_SUCCESS, DELETE_VENDOR_NOTE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/authNotes/${noteId}`,
      method: 'DELETE',
    },
  };
};

// VENDOR BAKING INFO

export const getAllVendorBanks = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_BANKING_INFO_REQUEST, GET_VENDOR_BANKING_INFO_SUCCESS, GET_VENDOR_BANKING_INFO_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/banking',
      method: 'GET',
    },
  };
};

export const getVendorBank = (bankId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_BANKING_INFO_BY_ID_REQUEST, GET_VENDOR_BANKING_INFO_BY_ID_SUCCESS, GET_VENDOR_BANKING_INFO_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/banking/getById/${bankId}`,
      method: 'GET',
    },
  };
};


export const getVendorBanksByVendorId = (vendorId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_REQUEST, GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_SUCCESS, GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/banking/${vendorId}`,
      method: 'GET',
    },
  };
};

export const postVendorBankingInfo = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VENDOR_BANKING_INFO_REQUEST, POST_VENDOR_BANKING_INFO_SUCCESS, POST_VENDOR_BANKING_INFO_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/banking',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateVendorBankingInfo = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_VENDOR_BANKING_INFO_REQUEST, UPDATE_VENDOR_BANKING_INFO_SUCCESS, UPDATE_VENDOR_BANKING_INFO_FAILURE],
      authenticated: true,
      endpoint: 'api/Vendors/banking',
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteVendorBankingInfo = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VENDOR_BANKING_INFO_REQUEST, DELETE_VENDOR_BANKING_INFO_SUCCESS, DELETE_VENDOR_BANKING_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/Vendors/banking/${id}`,
      method: 'DELETE',
    },
  };
};

  export const morrealeEquityImport = (values) => {
    return {
      [CALL_INTAKE_V2_API]: {
        types: [MORREALE_EQUITY_IMPORT_REQUEST, MORREALE_EQUITY_IMPORT_SUCCESS, MORREALE_EQUITY_IMPORT_FAILURE],
        authenticated: true,
        endpoint: 'api/integrations/homesaleEquity',
        method: 'POST',
        payload: values,
      },
    };
  };
